//import logo from './logo.svg';
import "./App.css";
import "./assets/css/bootstrap.min.css";
//import './assets/css/font-awesome.min.css';
import "./assets/css/main.css";
import "./assets/css/rpd.css";
import { Amplify, Auth } from "aws-amplify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/auth/AuthContext";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import SignOut from "./components/auth/SignOut";
import TestAuthPage from "./components/auth/TestAuthPage";
import Header from "./components/Header";
import Home from "./components/Home";
import Next from "./components/Next";
import Members from "./components/Members";
import First4 from "./components/First4";
import Tools from "./components/Tools";
import Footer from "./components/Footer";
import Success from "./components/Success";
import StripePricingTable from "./components/StripePricingTable";
import Merch from "./components/Merch";
import SubscriptionPage from "./components/Subscription";
import SubscriptionValidation from "./components/SubscriptionValidation";
import SubscriptionManagement from "./components/SubscriptionManagement";
import ResetPassword from "./components/auth/ResetPassword";
import Drink from "./components/Drink";

async function refreshToken() {
    // refresh the token here and get the new token info
    // ......
    // const userSession = getUserSession();
    // const token = userSession.idToken.jwtToken;
    // const expires_at = userSession.idToken.payload.exp * 1000; // Convert to milliseconds

    const session = await Auth.currentSession();

    const token = session.getIdToken().getJwtToken();
    const expires_at = session.getIdToken().getExpiration() * 1000; // Convert to milliseconds

    const identity_id = null;

    const data = {
        token, // the token from the provider
        expires_at, // the timestamp for the expiration
        identity_id, // optional, the identityId for the credentials
    };

    return data;
}

Amplify.configure({
    Auth: {
        region: "ap-southeast-2",
        userPoolId: "ap-southeast-2_Ar79EBArz",
        userPoolWebClientId: "1f7ph2vfcoandd21kkpgj3jbqp",
        // refreshHandlers: {
        //   'developer': refreshToken
        // }
    },
});

function App() {
    return (
        <AuthProvider>
            <Router basename="/">
                <Header />
                <Drink />
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    {/* <Route exact path="/merch"  element={<Merch />} /> */}
                    <Route exact path="/freetrial"  element={<StripePricingTable />} />
                    <Route exact path="/signin" element={<SignIn />} />
                    <Route exact path="/login" element={<SignIn />} />
                    <Route exact path="/signup" element={<SignUp />} />
                    <Route exact path="/signout" element={<SignOut />} />
                    <Route path="/TestAuthPage" element={<TestAuthPage />} />
                    <Route path="/signin2" element={<SignIn />} />
                    <Route
                        path="/subscription"
                        element={<SubscriptionPage />}
                    />
                    <Route
                        path="/subscriptionvalidation"
                        element={<SubscriptionValidation />}
                    />
                    <Route path="/success" element={<Success />} />
                    <Route path="/next" element={<Next />} />
                    <Route
                        path="/members"
                        element={<ProtectedRoute component={Members} />}
                    />
                    <Route
                        path="/first4"
                        element={<ProtectedRoute component={First4} />}
                    />
                    <Route path="/tools" element={<Tools />} />
                    <Route
                        path="/SubscriptionManagement"
                        element={
                            <ProtectedRoute
                                component={SubscriptionManagement}
                            />
                        }
                    />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    {/* ... other routes */}
                </Routes>
                <Footer />
            </Router>
        </AuthProvider>
    );
}

export default App;
